export default "__VITE_ASSET__b278e33e__"